import { apiConstants } from "../../../../utils/apiConstants";
import { apiTypes } from "../../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../../utils/getAxiosCancelToken";
import apiRequestType from "../../../apiRequestType";

let cancelToken;
const getUserGroup = () => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.COMMON.GET_USER_GROUP,
    cancelToken
  );
};

export default getUserGroup;
